"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const App_vue_1 = tslib_1.__importDefault(require("@/App.vue"));
const router_1 = tslib_1.__importDefault(require("@/router"));
const store_1 = tslib_1.__importDefault(require("@/store"));
const api_1 = tslib_1.__importDefault(require("@/api"));
const element_plus_1 = tslib_1.__importDefault(require("element-plus"));
require("element-plus/dist/index.css");
require("@/assets/styles/index.scss");
const zh_cn_mjs_1 = tslib_1.__importDefault(require("element-plus/dist/locale/zh-cn.mjs"));
const ElIconModules = tslib_1.__importStar(require("@element-plus/icons-vue"));
const index_vue_1 = tslib_1.__importDefault(require("@/components/SvgIcon/index.vue"));
const net_1 = require("@/rpc/lib/net");
require("animate.css");
const auto_focus_1 = tslib_1.__importDefault(require("@/directive/auto_focus"));
const vuedraggable_1 = tslib_1.__importDefault(require("vuedraggable"));
const app = (0, vue_1.createApp)(App_vue_1.default);
app.provide('$api', api_1.default);
app.component('svg-icon', index_vue_1.default);
app.component('draggable', vuedraggable_1.default);
app.directive('auto-focus', auto_focus_1.default);
const req = require.context('@/assets/icons/svg', false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);
window['onFlutterEvent'] = (event, brand, data) => {
    console.log('data', event, brand, data);
    if (event.includes('socket')) {
        net_1.net.Socket.current().onEvent(event, brand, data);
    }
    else if (event.includes('sftp')) {
        net_1.net.SFtp.current().onEvent(event, brand, data);
    }
};
for (const iconName in ElIconModules) {
    if (Reflect.has(ElIconModules, iconName)) {
        const item = ElIconModules[iconName];
        app.component(iconName, item);
    }
}
app
    .use(store_1.default)
    .use(router_1.default)
    .use(element_plus_1.default, { locale: zh_cn_mjs_1.default })
    .mount('#app');
document.oncontextmenu = () => false;
window.addEventListener('keydown', function (e) {
    if (e.key === "s" && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
        e.preventDefault();
    }
});
console.log('screen.height', screen.height);
console.log('screen.width', screen.width);
if (screen.height < 600) {
    document.body.setAttribute('class', 'mobile-body-size');
}
